<fc-content-image [details]="content.image"></fc-content-image>